<template>
  <div>
    <Layout :pagetitle="$t('CPA report')">
      <b-card>
        <b-row>
          <b-col class="m-2">
            <b-row>
              <b-col md="3">
                <label>{{ $t('Brand') }}</label>
                <brandSelectorUnique :modelValue="idBrand" @onChange="changeBrandFilter" />
              </b-col>
              <b-col md="3">
                <label>{{ $t('Data Início') }}</label>
                <input class="form-control" type="date" v-model="startDate" />
              </b-col>
              <b-col md="3">
                <label>{{ $t('Data Fim') }}</label>
                <input class="form-control" type="date" v-model="endDate" />
              </b-col>
              <b-col md="3">
                <label>{{ $t('Affiliate') }} - Token</label>
                <b-form-input v-model="token" maxlength="6" />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="8" />
              <b-col md="4">
                <div class="table-buttons">
                  <button class="btn btn-sm btn-success" :disabled="!reportData.length" @click="downloadXls">
                    {{ $t('XLS') }}
                  </button>
                  <button
                    class="ml-1 btn btn-sm btn-primary"
                    :disabled="!idBrand || !startDate || !endDate"
                    @click="getReport"
                  >
                    {{ $t('Buscar') }}
                  </button>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row v-if="reportData.length && !hideCpa">
          <b-col class="">
            <div class="card my-0 py-0 border border-primary">
              <div class="card-header bg-transparent border-primary py-0">
                <h5 class="my-0 text-primary">
                  <i :class="`fas fa-ticket-alt me-3`"></i>
                  {{ $t('Summary') }}
                </h5>
              </div>
              <div class="card-body">
                <div class="row d-flex">
                  <div class="col-md-3">
                    <span class="text-muted small d-block">
                      {{ $t('Quantidade') }}
                    </span>
                    <span class="h5 text-center"> {{ sumQtdCpa }} </span>
                  </div>
                  <div class="col-md-3">
                    <span class="text-muted small d-block">
                      {{ $t('CPA') }}
                    </span>
                    <span class="h5 text-center"> {{ $utils.formatMoneyFloat(sumTotalCpa) }} </span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <Table
          :key="hideCpa"
          :title="''"
          :items="tableData"
          :columns="columns"
          :totalItems="totalItems"
          :showButtons="false"
          :searchable="false"
          :editable="false"
          :removable="false"
          :showPagination="true"
          :isCard="false"
          @onChangePage="changePage"
        />
      </b-card>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';
import staticData from './staticData';
import { exportXls } from './functions';
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';
import moment from 'moment';
import utils from '@/utils/functions';

export default {
  components: {
    Layout,
    Table,
    brandSelectorUnique
  },
  beforeRouteEnter(to, from, next) {
    if (utils.checkOcultarCpa()) {
      next({ name: 'home' });
    } else {
      next();
    }
  },
  data() {
    return {
      startDate: moment(moment().format('YYYY-MM')).subtract('months', 1).format('YYYY-MM-DD'),
      endDate: moment(moment().format('YYYY-MM')).subtract('days', 1).format('YYYY-MM-DD'),
      idBrand: null,
      token: '',
      reportData: [],
      totalItems: 0,
      currentPage: 1,
      perPage: 10
    };
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
    },
    getReport() {
      let payload = {
        idBrand: this.idBrand,
        startDate: this.startDate,
        endDate: this.endDate
      };

      if (this.token) {
        payload['token'] = this.token;
      }

      // diference between startDate and endDate not can be more than one month
      if (moment(this.endDate).diff(moment(this.startDate), 'days') > 31) {
        this.$customAlert({
          type: 'warning',
          msg: 'The difference between start date and end date must be less than one month'
        });
        return;
      }

      this.$store.commit('SET_LOADING', true);
      this.$api
        .get('api/affiliateCpaReport', payload)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.reportData = this.loadReportData(res?.data || []);
          this.totalItems = res?.data?.length;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    loadReportData(reportData = []) {
      reportData = reportData.map((i) => {
        let entry_value = 0;
        let qtd_cpa = 0;

        entry_value = parseFloat(i?.entry_value || 0);
        qtd_cpa = parseFloat(i?.qtd_cpa || 0);

        return {
          ...i,
          entry_value: entry_value,
          qtd_cpa: qtd_cpa
        };
      });

      return reportData;
    },
    changeBrandFilter(idBrand) {
      this.idBrand = idBrand;
    },
    downloadXls() {
      exportXls([...this.reportData]);
    }
  },
  computed: {
    hideCpa() {
      this.$store.state.companySettings;
      return this.shouldHideCpa();
    },
    columns() {
      this.$store.state.companySettings;
      let cols = staticData().columns;
      if (this.hideCpa) {
        cols = cols.filter(
          (col) => col.key !== 'reward_slug' && col.key !== 'entry_value' && col.key !== 'qtd_cpa'
        );
      }
      return cols;
    },
    tableData() {
      let data = this.reportData.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
      return data;
    },
    sumTotalCpa() {
      return this.reportData.reduce((acc, curr) => acc + curr.entry_value, 0);
    },
    sumQtdCpa() {
      return this.reportData.reduce((acc, curr) => acc + curr.qtd_cpa, 0);
    }
  }
};
</script>
